import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { FlaskConical, BrainCircuit, Users, ShieldCheck } from 'lucide-react';

const pillars = [
  {
    icon: <FlaskConical size={20} strokeWidth={1.5} />,
    title: 'Scientific Assessments',
    desc: 'Structured career and psychological assessments informed by research-backed methodology.',
  },
  {
    icon: <BrainCircuit size={20} strokeWidth={1.5} />,
    title: 'AI-Supported Reports',
    desc: 'Advanced AI interprets results into clear career roadmaps, stream guidance, and advisory reports.',
  },
  {
    icon: <Users size={20} strokeWidth={1.5} />,
    title: 'Expert Counselors',
    desc: 'Human counselors provide personalized career planning, college guidance, and developmental support.',
  },
  {
    icon: <ShieldCheck size={20} strokeWidth={1.5} />,
    title: 'Secure Data Handling',
    desc: 'Your personal data is handled with the highest standards of privacy and care.',
  },
];

const TrustBar = () => {
  const [ref, visible] = useScrollReveal();
  return (
    <section
      ref={ref}
      style={{
        padding: '40px 24px',
        background: 'rgba(255,255,255,0.6)',
        borderTop: '1px solid rgba(42,157,143,0.1)',
        borderBottom: '1px solid rgba(42,157,143,0.1)',
      }}
      data-testid="trust-bar"
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '24px' }}>
          {pillars.map((p, i) => (
            <div
              key={p.title}
              className={`reveal reveal-delay-${i + 1} ${visible ? 'visible' : ''}`}
              style={{ display: 'flex', alignItems: 'flex-start', gap: '14px' }}
              data-testid={`trust-pillar-${i}`}
            >
              <div style={{
                width: '40px', height: '40px', minWidth: '40px',
                background: 'rgba(42,157,143,0.1)', borderRadius: '10px',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: '#2A9D8F'
              }}>{p.icon}</div>
              <div>
                <div style={{ fontFamily: 'Manrope', fontWeight: 600, fontSize: '14px', color: '#1A202C', marginBottom: '2px' }}>{p.title}</div>
                <div style={{ fontSize: '12px', color: '#64748B', lineHeight: 1.5, fontFamily: 'Inter' }}>{p.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
